import React, { useState } from 'react';
import Button from './Button';

/**
 * Hộp thoại cảnh báo dùng chung.
 *
 * `secondaryLabel`/`onSecondary` thêm MỘT lựa chọn thứ ba ở giữa — phòng thi dùng nó cho
 * "Thoát không nộp" (feedback 23/09), để học viên có đường ra mà không đẩy một bài dở
 * vào bảng kết quả. Không truyền thì hộp thoại giữ nguyên hai nút như cũ.
 */
const AlertForm = ({ open, onClose, onConfirm, title, message,
                     confirmLabel, busyLabel, secondaryLabel, onSecondary }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    if (isSubmitting) return; // Ngăn chặn nhiều lần nhấp
    setIsSubmitting(true);
    await onConfirm();
    setIsSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl p-6 max-w-[500px] w-full shadow-lg">
        <h2 className="text-xl font-bold text-center text-red-600 mb-4">
          {title || 'Cảnh báo'}
        </h2>
        
        <div className="my-6 text-center text-gray-700">
          {message || 'Bạn có chắc chắn muốn rời khỏi trang này? Tiến trình làm bài của bạn sẽ bị mất.'}
        </div>
        
        <div className="flex flex-wrap justify-between gap-3 mt-6">
          <Button
            onClick={onClose}
            variant="outlined"
            className="flex-1 px-6 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-lg"
            disabled={isSubmitting}
          >
            Hủy
          </Button>
          {secondaryLabel && (
            <Button
              onClick={onSecondary}
              variant="outlined"
              className="flex-1 px-6 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-lg"
              disabled={isSubmitting}
            >
              {secondaryLabel}
            </Button>
          )}
          <Button
            onClick={handleConfirm}
            variant="contained"
            className="flex-1 px-6 py-2 bg-red-600 text-black hover:bg-red-700 rounded-lg"
            disabled={isSubmitting}
            autoFocus
          >
            {isSubmitting ? (busyLabel || 'Đang nộp bài...') : (confirmLabel || 'Xác nhận')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AlertForm;
